export class SubmitDelegateRequest {
  identityId?: string;
  employerId?: string;
  agentCode?: string;
}
